// extracted by mini-css-extract-plugin
export default {"grid":"AreaGroups_grid__ASlqm","panel":"AreaGroups_panel__y88-2","head":"AreaGroups_head__ZSeyN","pin":"AreaGroups_pin__h3O06","list":"AreaGroups_list__ozfX8"};